module.exports = __webpack_public_path__ + "img/CUS_N_1-1.d3ac69c5.jpg";